"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M22 6H12l-2-2H2v16h20zM12 17v-3H8v-2h4V9l4 4z"
}), 'DriveFileMoveSharp');